import db from "../../db";
import { UPDATE_PARAMETER_DATE_SYNCHRO, ERROR, SET_INDEXEDDB_TABLES } from "./parameterConstants";
import { throwErrorMessage, throwWarning } from "../../lib/error_helper";
import { formatBytesToSize } from "../../utils";

function getIndexedDbTablesAction(indexedDbTables) {
    return {
        type: SET_INDEXEDDB_TABLES,
        indexedDbTables,
    };
}

export function updateSynchroDate(user_id, date) {
    return (dispatch) => {
        db.transaction("rw?", db.Parameter, async () => {
            db.Parameter.update(user_id, { last_sync: date })
                .then(() => {
                    dispatch({ type: UPDATE_PARAMETER_DATE_SYNCHRO, payload: { user_id, date } });
                })
                .catch((err) => {
                    console.error("Erreur : parameterActions - updateSynchroDate");
                    dispatch(
                        throwErrorMessage({
                            errorObject: err,
                            title: "Erreur",
                            message: "Erreur lors de la modification de la date de synchronisation !",
                        })
                    );
                    dispatch({
                        type: ERROR,
                        info: "Accès BDD, update de la date de synchro pour l'utilisateur " + user_id,
                        error: err,
                    });
                });
        }).catch((err) => {
            console.error("Erreur : parameterActions - updateSynchroDate");
            dispatch(
                throwErrorMessage({
                    errorObject: err,
                    title: "Erreur",
                    message: "Erreur lors de la modification de la date de synchronisation !",
                })
            );
            dispatch({ type: ERROR, info: "Récupération de synchronisation", error: err });
        });
    };
}

export function dispatchWarning(title, message, dismissAction) {
    return (dispatch) => {
        dispatch(
            throwWarning({
                title: title,
                message: message,
                dismissAction: dismissAction,
            })
        );
    };
}

export function getIndexedDbTables() {
    return async (dispatch) => {
        let tables = [];
        await Promise.all(
            db.tables.map(async (tableInfo) => {
                return new Promise(async (resolve) => {
                    let nbLines = await tableInfo.count();
                    let memorySpace = await getTableSize(tableInfo);
                    let table = {
                        name: tableInfo.name,
                        nbLines,
                        memorySpace: formatBytesToSize(memorySpace),
                        unformatedMemorySpace: memorySpace,
                    };

                    tables.push(table);

                    return resolve(table);
                });
            })
        ).then(() => {
            dispatch(
                getIndexedDbTablesAction(tables.sort((a, b) => b.unformatedMemorySpace - a.unformatedMemorySpace))
            );
        });
    };
}

function getTableSize(table) {
    return new Promise((resolve) => {
        var size = 0;
        table
            .toCollection()
            .each((item) => {
                var json = JSON.stringify(item);
                size += json.length;
            })
            .then(() => {
                resolve(size);
            });
    });
}
